import { useEffect } from 'react';

import i18n, { ensureLanguageCatalog, i18nReady, setLanguage } from '@/i18n';

import { readPublicLanguage } from '../../../../landing/lib/public-language-preference';

export function useAuthLanguageSync(): void {
  useEffect(() => {
    const controller = new AbortController();
    let revision = 0;
    const sync = async () => {
      if (document.visibilityState === 'hidden') {
        return;
      }
      const request = ++revision;
      try {
        const preference = readPublicLanguage(document.cookie);
        if (!preference) {
          return;
        }
        const language = preference === 'fr' ? 'fr' : 'en';
        await i18nReady;
        if (i18n.resolvedLanguage === language) {
          return;
        }
        await ensureLanguageCatalog(language);
        if (!controller.signal.aborted && request === revision) {
          await setLanguage(language);
        }
      } catch {
        // Keep the loaded language offline; returning to the tab retries the catalog.
      }
    };
    const onResume = () => {
      void sync();
    };
    onResume();
    globalThis.addEventListener('focus', onResume);
    globalThis.addEventListener('pageshow', onResume);
    document.addEventListener('visibilitychange', onResume);
    return () => {
      controller.abort();
      globalThis.removeEventListener('focus', onResume);
      globalThis.removeEventListener('pageshow', onResume);
      document.removeEventListener('visibilitychange', onResume);
    };
  }, []);
}
